/* tslint:disable */
/* eslint-disable */
/**
 * GateHouse AIS REST interface
 * AIS system for monitoring vessel traffic. Commercial WebService. Contact GateHouse support for more information.
 *
 * The version of the OpenAPI document: 137
 * Contact: support@gatehouse.dk
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface ShapesImportPost200Response
 */
export interface ShapesImportPost200Response {
    /**
     * ID of the imported shape
     * @type {string}
     * @memberof ShapesImportPost200Response
     */
    id?: string;
}

/**
 * Check if a given object implements the ShapesImportPost200Response interface.
 */
export function instanceOfShapesImportPost200Response(value: object): boolean {
    let isInstance = true;

    return isInstance;
}

export function ShapesImportPost200ResponseFromJSON(json: any): ShapesImportPost200Response {
    return ShapesImportPost200ResponseFromJSONTyped(json, false);
}

export function ShapesImportPost200ResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): ShapesImportPost200Response {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'id': !exists(json, 'id') ? undefined : json['id'],
    };
}

export function ShapesImportPost200ResponseToJSON(value?: ShapesImportPost200Response | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'id': value.id,
    };
}

